import { type QuizQuestion, QuizQuestionType } from '@efdigital/ll-addon-data';
import { DataTypeQuiz } from '@efdigital/ll-addon-data/data-types';
import { Type } from '@warp-drive/core/types/symbols';

import { MultipleChoiceQuestionEditorComponent } from '../editors/question/choice-multiple.gts';
import { ReportingEditorComponent } from '../editors/reporting/reporting.gts';
import { MultipleChoiceResponseEditorComponent } from '../editors/response/choice-multiple.gts';
import { MultipleChoiceScoringEditorComponent } from '../editors/scoring/choice-multiple.gts';
import { type QuestionManager } from '../types/question-manager.ts';
import { DEFAULT_RESPONSE } from '../types/quiz-responses.ts';

export const MultipleChoiceQuestionManager: QuestionManager = {
  discriminator: (question: QuizQuestion) =>
    question.type === QuizQuestionType.Choice &&
    question.choice?.type === 'multiple',
  type: QuizQuestionType.Choice,
  icon: 'ph:check-square',
  editingIcon: 'ph:check-square-fill',
  editingLabel: 'Choices',
  label: 'Multiple Choice Question',
  questionComponent: MultipleChoiceQuestionEditorComponent,
  scoringComponent: MultipleChoiceScoringEditorComponent,
  responseComponent: MultipleChoiceResponseEditorComponent,
  reportingComponent: ReportingEditorComponent,
  defaultData: {
    choice: {
      [Type]: DataTypeQuiz.QuizQuestionChoice,
      choices: [],
      type: 'multiple',
      scoring: 'exact',
      score: 0,
      category: '',
      additionalCategories: [],
      format: 'buttons',
      custom: false,
      picklist: '',
      response: DEFAULT_RESPONSE,
      response0: DEFAULT_RESPONSE,
    },
    reporting: {
      [Type]: DataTypeQuiz.QuizReportingQuestion,
      groupName: '',
      questionName: '',
    },
  },
};
